'use client';

import { Box, Flex } from '@chakra-ui/react';
import type { BoxProps, FlexProps } from '@chakra-ui/react';

import type { PropsWithChildren } from 'react';

type HeaderProps = FlexProps & PropsWithChildren;

const Header = ({ children, ...other }: HeaderProps) => {
	return (
		<Flex
			flexDir={'column'}
			gap={4}
			{...other}
		>
			{children}
		</Flex>
	);
};

const Footer = ({ children, ...other }: BoxProps & PropsWithChildren) => {
	return (
		<Box {...other}>
			{children}
		</Box>
	);
};

const Content = ({ children, ...other }: BoxProps & PropsWithChildren) => {
	return (
		<Box
			{...other}
			flex={1}
			overflow={'auto'}
			pb={4}
		>
			{children}
		</Box>
	);
};

type FullHeightContainerProps = FlexProps & PropsWithChildren;

const FullHeightContainer = ({ children, ...other }:  FullHeightContainerProps) => {
	return (
		<Flex
			gap={8}
			{...other}
			flexDir={'column'}
			h={'100%'}
			overflow={'hidden'}
		>
			{children}
		</Flex>
	);
};

FullHeightContainer.Content = Content;
FullHeightContainer.Footer = Footer;
FullHeightContainer.Header = Header;

export default FullHeightContainer;